import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'
import http from './utils/http'

Vue.use(Vant)
Vue.prototype.$http = http

// 初始化用户状态
store.dispatch('initUserState');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
